<app-megamenu></app-megamenu>

<div class="landing-content">
  <!-- Hero Section -->
  <div class="hero-section">
    <div class="hero-background"></div>
    <div class="hero-container">
      <div class="hero-content">
        <h1>Northern Utah Pest Control Experts</h1>
        <p class="hero-subtitle">Trusted pest control services protecting Northern Utah homes for over a decade.</p>
        
        <div class="hero-features">
          <div class="feature-item">
            <mat-icon>verified</mat-icon>
            <span>Licensed & Insured</span>
          </div>
          <div class="feature-item">
            <mat-icon>schedule</mat-icon>
            <span>Service on Your Schedule</span>
          </div>
          <div class="feature-item">
            <mat-icon>eco</mat-icon>
            <span>Eco-Friendly Pest Solutions</span>
          </div>
        </div>
        
        <div class="hero-buttons">
          <button mat-raised-button class="primary-btn" (click)="navigateToContact()">
            Get Your Free Quote
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Features Section -->
  <div class="features-section">
    <div class="section-header">
      <h2>Why Choose Complete Pest?</h2>
      <p>Comprehensive pest control to protect your home or business.</p>
    </div>
    
    <div class="features">
      <div class="feature-card">
        <mat-icon>people</mat-icon>
        <h3>Professional Exterminators</h3>
        <p>Protecting homes, businesses, and people for over 10 years.</p>
      </div>
      
      <div class="feature-card">
        <mat-icon>schedule</mat-icon>
        <h3>Customizable Schedules</h3>
        <p>Routine Pest Control services built around your schedule.</p>
      </div>
      
      <div class="feature-card">
        <mat-icon>inventory</mat-icon>
        <h3>Guaranteed Service</h3>
        <p>If you see pests within 30 days of any service, we'll come back for free!</p>
      </div>
    </div>
  </div>
</div>

<!-- Service Offerings Section -->
<app-service-offerings></app-service-offerings>

<app-footer></app-footer>